import { useCallback, useEffect, useMemo, useState } from 'react';

export default function useAccordion(initialOpen = false, initialOpenIndex = 0) {
	const [accordionLength, setAccordionLength] = useState(0);
	const [accordionArray, setAccordionArray] = useState([]);
	const accordionStatsAll = useMemo(() => accordionArray.indexOf(false) !== -1, [accordionArray]);

	const handleAccordion = useCallback((current, options) => {
		setAccordionArray((state) => state.map((flag, i) => (current === i ? !flag : false)));

		if (options) {
			setTimeout(() => {
				window.scrollTo({
					top: (options?.target.clientHeight || 0) * current + (options?.offsetTop || 0),
				});
			}, 0);
		}
	}, []);

	const handleAccordionMulti = useCallback((current) => {
		setAccordionArray((state) => state.map((flag, i) => (current === i ? !flag : flag)));
	}, []);

	const handleAccordionAll = useCallback(() => {
		setAccordionArray(new Array(accordionLength).fill(accordionStatsAll));
	}, [accordionLength, accordionStatsAll]);

	useEffect(() => {
		setAccordionArray(new Array(accordionLength).fill(false));

		if (initialOpen) {
			handleAccordion(initialOpenIndex);
		}
	}, [accordionLength, handleAccordion, initialOpen, initialOpenIndex]);

	return {
		accordionStatsAll,
		setAccordionLength,
		accordionArray,
		handleAccordion,
		handleAccordionMulti,
		handleAccordionAll,
	};
}
